import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { CD_PARSE_YIELD_EVERY, MAX_ENTRY_BYTES } from '../config';
import { isPackError, PackError } from './errors';

// Browser port of evidence-cli's RemoteZipContainer (via the PR-909 viewer):
// same EOCD/ZIP64/central-directory walk, with DataView in place of Buffer
// and DecompressionStream in place of node:zlib. Hardened over the reference
// with typed errors, an encryption check, event-loop yielding on huge central
// directories, an optimistic single read per entry, and in-flight dedup.

// ZIP record signatures (little-endian uint32).
var SIG_EOCD = 0x06054b50; // end of central directory
var SIG_EOCD64 = 0x06064b50; // ZIP64 end of central directory record
var SIG_EOCD64_LOC = 0x07064b50; // ZIP64 EOCD locator
var SIG_CD = 0x02014b50; // central directory file header
var SIG_LFH = 0x04034b50; // local file header

var EOCD_MIN = 22; // EOCD without comment
var MAX_COMMENT = 0xffff;
var ZIP64_SENTINEL32 = 0xffffffff;
var ZIP64_SENTINEL16 = 0xffff;
var METHOD_STORE = 0;
var METHOD_DEFLATE = 8;
var FLAG_ENCRYPTED = 0x0001;

/** A single central-directory entry — everything needed to range-read its data. */

var utf8 = new TextDecoder();
var viewOf = function viewOf(b) {
  return new DataView(b.buffer, b.byteOffset, b.byteLength);
};
var u16 = function u16(v, off) {
  return v.getUint16(off, true);
};
var u32 = function u32(v, off) {
  return v.getUint32(off, true);
};
/** 8-byte LE value as a Number (offsets/sizes < 2^53; never realistic to exceed). */
var u64 = function u64(v, off) {
  return Number(v.getBigUint64(off, true));
};
var yieldToEventLoop = function yieldToEventLoop() {
  return new Promise(function (resolve) {
    return setTimeout(resolve, 0);
  });
};

/**
 * Inflate a raw-deflate entry, bounded by the central directory's declared
 * uncompressed size — a deflate bomb behind a lying CD aborts with a typed
 * error instead of over-allocating, and corrupt data never escapes as an
 * untyped DecompressionStream failure.
 */
function inflateRaw(_x, _x2, _x3) {
  return _inflateRaw.apply(this, arguments);
}
function _inflateRaw() {
  _inflateRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(data, entryName, maxBytes) {
    var ds, writer, writing, reader, chunks, total, _yield$reader$read, done, value, out, o, _i, _chunks, c, _t2;
    return _regeneratorRuntime.wrap(function (_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          ds = new DecompressionStream('deflate-raw');
          writer = ds.writable.getWriter(); // Single-chunk write; don't await it before reading or a full internal
          // queue would deadlock. Errors surface through the reader below.
          writing = writer.write(data).then(function () {
            return writer.close();
          });
          writing["catch"](function () {
            return undefined;
          });
          reader = ds.readable.getReader();
          chunks = [];
          total = 0;
          _context1.prev = 1;
        case 2:
          _context1.next = 3;
          return reader.read();
        case 3:
          _yield$reader$read = _context1.sent;
          done = _yield$reader$read.done;
          value = _yield$reader$read.value;
          if (!done) {
            _context1.next = 4;
            break;
          }
          return _context1.abrupt("continue", 8);
        case 4:
          total += value.byteLength;
          if (!(total > maxBytes)) {
            _context1.next = 6;
            break;
          }
          _context1.next = 5;
          return reader.cancel();
        case 5:
          throw new PackError('corrupt-entry', "".concat(entryName, " inflates beyond its declared size (").concat(maxBytes, ")"), {
            entry: entryName
          });
        case 6:
          chunks.push(value);
        case 7:
          _context1.next = 2;
          break;
        case 8:
          _context1.next = 11;
          break;
        case 9:
          _context1.prev = 9;
          _t2 = _context1["catch"](1);
          if (!isPackError(_t2)) {
            _context1.next = 10;
            break;
          }
          throw _t2;
        case 10:
          throw new PackError('corrupt-entry', "corrupt DEFLATE data in ".concat(entryName), {
            entry: entryName
          });
        case 11:
          out = new Uint8Array(total);
          o = 0;
          for (_i = 0, _chunks = chunks; _i < _chunks.length; _i++) {
            c = _chunks[_i];
            out.set(c, o);
            o += c.byteLength;
          }
          return _context1.abrupt("return", out);
        case 12:
        case "end":
          return _context1.stop();
      }
    }, _callee1, null, [[1, 9]]);
  }));
  return _inflateRaw.apply(this, arguments);
}
function stripEvidence(base) {
  return base.replace(/\.evidence$/, '');
}

/**
 * Scan a tail window backwards for the EOCD signature, honouring the comment
 * length so a stray signature inside a comment can't fool us. -1 if absent.
 */
function scanForEocd(tail) {
  var v = viewOf(tail);
  for (var i = tail.length - EOCD_MIN; i >= 0; i--) {
    if (u32(v, i) !== SIG_EOCD) continue;
    var commentLen = u16(v, i + 20);
    if (i + EOCD_MIN + commentLen === tail.length) return i;
  }
  return -1;
}

/** Small first probe — finalize writes no archive comment, so the EOCD is
 * almost always in the last 4 KiB; only a commented zip needs the max window. */
var EOCD_PROBE = 4 * 1024;
/**
 * Locate and parse the (optionally ZIP64) End-Of-Central-Directory, returning
 * the central directory's byte offset and size. Reads only the tail of the
 * source — never the whole archive.
 */
function readEocd(_x4, _x5) {
  return _readEocd.apply(this, arguments);
}
/** Apply ZIP64 overrides from a central-header extra field to the sentinel values. */
function _readEocd() {
  _readEocd = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(src, opts) {
    var total, tailLen, tail, p, v, count, cdSize, cdOffset, needsZip64, eocdStart, locPos, loc, resolved, z64Offset, inTail, z64, zv, _t3, _t4, _t5;
    return _regeneratorRuntime.wrap(function (_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 1;
          return src.size(opts);
        case 1:
          total = _context10.sent;
          tailLen = Math.min(total, EOCD_PROBE);
          _context10.next = 2;
          return src.read(total - tailLen, tailLen, opts);
        case 2:
          tail = _context10.sent;
          p = scanForEocd(tail);
          if (!(p === -1 && total > tailLen)) {
            _context10.next = 4;
            break;
          }
          tailLen = Math.min(total, EOCD_MIN + MAX_COMMENT);
          _context10.next = 3;
          return src.read(total - tailLen, tailLen, opts);
        case 3:
          tail = _context10.sent;
          p = scanForEocd(tail);
        case 4:
          if (!(p === -1)) {
            _context10.next = 5;
            break;
          }
          throw new PackError('not-a-zip', 'not a zip: end-of-central-directory not found');
        case 5:
          v = viewOf(tail);
          count = u16(v, p + 10);
          cdSize = u32(v, p + 12);
          cdOffset = u32(v, p + 16);
          needsZip64 = count === ZIP64_SENTINEL16 || cdSize === ZIP64_SENTINEL32 || cdOffset === ZIP64_SENTINEL32;
          if (!needsZip64) {
            _context10.next = 15;
            break;
          }
          // The ZIP64 EOCD locator sits immediately before the EOCD (20 bytes) —
          // possibly before the fetched tail window when the EOCD landed at its
          // start (large archive comments). Never proceed with sentinel values:
          // that would open a valid ZIP64 archive as an empty pack.
          eocdStart = total - tailLen;
          locPos = p - 20;
          if (!(locPos >= 0)) {
            _context10.next = 6;
            break;
          }
          _t3 = tail.subarray(locPos, locPos + 20);
          _context10.next = 10;
          break;
        case 6:
          if (!(eocdStart + locPos >= 0)) {
            _context10.next = 8;
            break;
          }
          _context10.next = 7;
          return src.read(eocdStart + locPos, 20, opts);
        case 7:
          _t4 = _context10.sent;
          _context10.next = 9;
          break;
        case 8:
          _t4 = null;
        case 9:
          _t3 = _t4;
        case 10:
          loc = _t3;
          resolved = false;
          if (!(loc && loc.length === 20 && u32(viewOf(loc), 0) === SIG_EOCD64_LOC)) {
            _context10.next = 14;
            break;
          }
          z64Offset = u64(viewOf(loc), 8); // The ZIP64 EOCD record may live before our tail window — read it directly.
          inTail = z64Offset - eocdStart;
          if (!(inTail >= 0 && inTail + 56 <= tail.length)) {
            _context10.next = 11;
            break;
          }
          _t5 = tail.subarray(inTail, inTail + 56);
          _context10.next = 13;
          break;
        case 11:
          _context10.next = 12;
          return src.read(z64Offset, 56, opts);
        case 12:
          _t5 = _context10.sent;
        case 13:
          z64 = _t5;
          if (z64.length >= 56 && u32(viewOf(z64), 0) === SIG_EOCD64) {
            zv = viewOf(z64);
            cdSize = u64(zv, 40);
            cdOffset = u64(zv, 48);
            resolved = true;
          }
        case 14:
          if (resolved) {
            _context10.next = 15;
            break;
          }
          throw new PackError('not-a-zip', 'ZIP64 archive: end-of-central-directory locator/record not found');
        case 15:
          return _context10.abrupt("return", {
            cdOffset: cdOffset,
            cdSize: cdSize,
            tail: tail,
            tailStart: total - tailLen
          });
        case 16:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _readEocd.apply(this, arguments);
}
function applyZip64Extra(extra, e) {
  var v = viewOf(extra);
  var i = 0;
  while (i + 4 <= extra.length) {
    var id = u16(v, i);
    var size = u16(v, i + 2);
    var body = i + 4;
    if (id === 0x0001) {
      // Fields appear in fixed order, only for those that overflowed to
      // sentinel. Clamp to the bytes actually present — a lying self-declared
      // size must not read past the DataView (untyped RangeError).
      var limit = Math.min(body + size, extra.length);
      var o = body;
      if (e.uncompressedSize === ZIP64_SENTINEL32 && o + 8 <= limit) {
        e.uncompressedSize = u64(v, o);
        o += 8;
      }
      if (e.compressedSize === ZIP64_SENTINEL32 && o + 8 <= limit) {
        e.compressedSize = u64(v, o);
        o += 8;
      }
      if (e.localHeaderOffset === ZIP64_SENTINEL32 && o + 8 <= limit) {
        e.localHeaderOffset = u64(v, o);
        o += 8;
      }
      return;
    }
    i = body + size;
  }
}

/**
 * Parse the central directory bytes into an ordered list of entries, yielding
 * to the event loop periodically so a 20k-entry directory can't block a frame.
 */
function parseCentralDirectory(_x6) {
  return _parseCentralDirectory.apply(this, arguments);
}
/** A shared in-flight entry read plus the bookkeeping that lets each waiter
 * keep its own abort semantics: the underlying read is cancelled only when
 * EVERY joined waiter has aborted. */
function _parseCentralDirectory() {
  _parseCentralDirectory = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(cd) {
    var v, entries, i, flags, method, compressedSize, uncompressedSize, nameLen, extraLen, commentLen, localHeaderOffset, name, extra, entry;
    return _regeneratorRuntime.wrap(function (_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          v = viewOf(cd);
          entries = [];
          i = 0;
        case 1:
          if (!(i + 46 <= cd.length && u32(v, i) === SIG_CD)) {
            _context11.next = 3;
            break;
          }
          flags = u16(v, i + 8);
          method = u16(v, i + 10);
          compressedSize = u32(v, i + 20);
          uncompressedSize = u32(v, i + 24);
          nameLen = u16(v, i + 28);
          extraLen = u16(v, i + 30);
          commentLen = u16(v, i + 32);
          localHeaderOffset = u32(v, i + 42);
          name = utf8.decode(cd.subarray(i + 46, i + 46 + nameLen));
          extra = cd.subarray(i + 46 + nameLen, i + 46 + nameLen + extraLen);
          entry = {
            name: name,
            method: method,
            flags: flags,
            compressedSize: compressedSize,
            uncompressedSize: uncompressedSize,
            localHeaderOffset: localHeaderOffset,
            cdNameLen: nameLen,
            cdExtraLen: extraLen
          };
          if (compressedSize === ZIP64_SENTINEL32 || uncompressedSize === ZIP64_SENTINEL32 || localHeaderOffset === ZIP64_SENTINEL32) {
            applyZip64Extra(extra, entry);
          }
          entries.push(entry);
          if (!(entries.length % CD_PARSE_YIELD_EVERY === 0)) {
            _context11.next = 2;
            break;
          }
          _context11.next = 2;
          return yieldToEventLoop();
        case 2:
          i += 46 + nameLen + extraLen + commentLen;
          _context11.next = 1;
          break;
        case 3:
          return _context11.abrupt("return", entries);
        case 4:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _parseCentralDirectory.apply(this, arguments);
}
var ZipPackContainer = /*#__PURE__*/function () {
  function ZipPackContainer(src, packName, entries) {
    _classCallCheck(this, ZipPackContainer);
    /** All entry names (including any explicit directory entries) for prefix ops. */
    /** Concurrent reads of the same entry share one promise. */
    _defineProperty(this, "inflight", new Map());
    this.src = src;
    this.packName = packName;
    this.entries = entries;
    this.byName = new Map();
    this.names = [];
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        this.names.push(e.name);
        if (!e.name.endsWith('/')) this.byName.set(e.name, e);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return _createClass(ZipPackContainer, [{
    key: "name",
    get: function get() {
      return stripEvidence(this.packName);
    }

    /**
     * Range-read and decompress a single entry's bytes, or null if absent.
     * Concurrent reads of the same entry share one underlying read, but each
     * caller aborts independently: a waiter's abort rejects only that waiter;
     * the shared read itself is cancelled once ALL waiters have aborted.
     */
  }, {
    key: "readEntryBytes",
    value: function readEntryBytes(entryName, opts) {
      var _this = this;
      var running = this.inflight.get(entryName);
      if (!running) {
        var controller = new AbortController();
        var entry = {
          controller: controller,
          waiters: 0,
          aborted: 0,
          promise: this.readEntryBytesUncached(entryName, {
            signal: controller.signal
          })["finally"](function () {
            _this.inflight["delete"](entryName);
          })
        };
        this.inflight.set(entryName, entry);
        running = entry;
      }
      return this.joinInflight(running, opts === null || opts === void 0 ? void 0 : opts.signal);
    }
  }, {
    key: "joinInflight",
    value: function joinInflight(entry, signal) {
      if (!signal) return entry.promise;
      if (signal.aborted) {
        throw new PackError('aborted', 'operation aborted');
      }
      entry.waiters += 1;
      return new Promise(function (resolve, reject) {
        var onAbort = function onAbort() {
          entry.aborted += 1;
          if (entry.aborted >= entry.waiters) entry.controller.abort();
          reject(new PackError('aborted', 'operation aborted'));
        };
        signal.addEventListener('abort', onAbort, {
          once: true
        });
        entry.promise.then(resolve, reject)["finally"](function () {
          return signal.removeEventListener('abort', onAbort);
        });
      });
    }
  }, {
    key: "readEntryBytesUncached",
    value: function () {
      var _readEntryBytesUncached = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(entryName, opts) {
        var e, guessLen, buf, v, nameLen, extraLen, dataStart, dataEnd, raw, have, rest;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e = this.byName.get(entryName);
              if (e) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", null);
            case 1:
              if (!((e.flags & FLAG_ENCRYPTED) !== 0)) {
                _context.next = 2;
                break;
              }
              throw new PackError('corrupt-entry', "encrypted entry ".concat(entryName), {
                entry: entryName
              });
            case 2:
              if (!(e.uncompressedSize > MAX_ENTRY_BYTES || e.compressedSize > MAX_ENTRY_BYTES)) {
                _context.next = 3;
                break;
              }
              throw new PackError('entry-too-large', "".concat(entryName, " is ").concat(e.uncompressedSize, " bytes uncompressed / ") + "".concat(e.compressedSize, " compressed (limit ").concat(MAX_ENTRY_BYTES, ")"), {
                entry: entryName,
                size: e.uncompressedSize,
                limit: MAX_ENTRY_BYTES
              });
            case 3:
              // Optimistic single read: local header + data in one request, sized by the
              // central directory's name/extra lengths. The local header's lengths can
              // legally differ — when they do, issue one corrective read for the tail.
              guessLen = 30 + e.cdNameLen + e.cdExtraLen + e.compressedSize;
              _context.next = 4;
              return this.src.read(e.localHeaderOffset, guessLen, opts);
            case 4:
              buf = _context.sent;
              v = viewOf(buf);
              if (!(buf.length < 30 || u32(v, 0) !== SIG_LFH)) {
                _context.next = 5;
                break;
              }
              throw new PackError('corrupt-entry', "corrupt local header for ".concat(entryName), {
                entry: entryName
              });
            case 5:
              nameLen = u16(v, 26);
              extraLen = u16(v, 28);
              dataStart = 30 + nameLen + extraLen;
              dataEnd = dataStart + e.compressedSize;
              if (!(dataEnd <= buf.length)) {
                _context.next = 6;
                break;
              }
              raw = buf.subarray(dataStart, dataEnd);
              _context.next = 9;
              break;
            case 6:
              // Local lengths exceeded the CD's guess — fetch the missing data once.
              // `have` bytes of real data are already in hand; the corrective read
              // starts at the true data position, which sits BEYOND buf.length when
              // the LFH surplus exceeds the entry's compressed size.
              have = Math.max(0, buf.length - dataStart);
              _context.next = 7;
              return this.src.read(e.localHeaderOffset + dataStart + have, e.compressedSize - have, opts);
            case 7:
              rest = _context.sent;
              if (!(rest.length < e.compressedSize - have)) {
                _context.next = 8;
                break;
              }
              throw new PackError('corrupt-entry', "truncated entry data for ".concat(entryName), {
                entry: entryName
              });
            case 8:
              raw = new Uint8Array(e.compressedSize);
              if (have > 0) raw.set(buf.subarray(dataStart, dataStart + have), 0);
              raw.set(rest.subarray(0, e.compressedSize - have), have);
            case 9:
              if (!(e.method === METHOD_STORE)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", raw);
            case 10:
              if (!(e.method === METHOD_DEFLATE)) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return", inflateRaw(raw, entryName, e.uncompressedSize));
            case 11:
              throw new PackError('unsupported-compression', "unsupported compression method ".concat(e.method, " for ").concat(entryName), {
                method: e.method,
                entry: entryName
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function readEntryBytesUncached(_x7, _x8) {
        return _readEntryBytesUncached.apply(this, arguments);
      }
      return readEntryBytesUncached;
    }()
  }, {
    key: "readEntryText",
    value: function () {
      var _readEntryText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entryName, opts) {
        var b;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return this.readEntryBytes(entryName, opts);
            case 1:
              b = _context2.sent;
              return _context2.abrupt("return", b ? utf8.decode(b) : null);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function readEntryText(_x9, _x0) {
        return _readEntryText.apply(this, arguments);
      }
      return readEntryText;
    }() /** True if any entry sits under `<rel>/` — i.e. rel names a directory. */
  }, {
    key: "hasPrefix",
    value: function hasPrefix(rel) {
      var prefix = rel.endsWith('/') ? rel : "".concat(rel, "/");
      return this.names.some(function (n) {
        return n.startsWith(prefix);
      });
    }
  }, {
    key: "readManifest",
    value: function () {
      var _readManifest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(opts) {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.readEntryText('run.yaml', opts));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function readManifest(_x1) {
        return _readManifest.apply(this, arguments);
      }
      return readManifest;
    }()
  }, {
    key: "listTestIds",
    value: function () {
      var _listTestIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var ids, _iterator2, _step2, n, m;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              ids = new Set();
              _iterator2 = _createForOfIteratorHelper(this.names);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  n = _step2.value;
                  m = n.match(/^tests\/([^/]+)\//);
                  if (m) ids.add(m[1]);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              return _context4.abrupt("return", _toConsumableArray(ids).sort());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function listTestIds() {
        return _listTestIds.apply(this, arguments);
      }
      return listTestIds;
    }()
  }, {
    key: "readResult",
    value: function () {
      var _readResult = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(testId, opts) {
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.readEntryText("tests/".concat(testId, "/result.yaml"), opts));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function readResult(_x10, _x11) {
        return _readResult.apply(this, arguments);
      }
      return readResult;
    }()
  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(rel) {
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.byName.has(rel) || this.hasPrefix(rel));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function exists(_x12) {
        return _exists.apply(this, arguments);
      }
      return exists;
    }()
  }, {
    key: "isDir",
    value: function () {
      var _isDir = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(rel) {
        return _regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.hasPrefix(rel));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function isDir(_x13) {
        return _isDir.apply(this, arguments);
      }
      return isDir;
    }()
  }, {
    key: "listDir",
    value: function () {
      var _listDir = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(rel) {
        var prefix, children, _iterator3, _step3, n, rest, slash, _t;
        return _regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              prefix = rel === '' ? '' : rel.endsWith('/') ? rel : "".concat(rel, "/");
              children = new Map(); // name -> isDir
              _iterator3 = _createForOfIteratorHelper(this.names);
              _context8.prev = 1;
              _iterator3.s();
            case 2:
              if ((_step3 = _iterator3.n()).done) {
                _context8.next = 6;
                break;
              }
              n = _step3.value;
              if (n.startsWith(prefix)) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("continue", 5);
            case 3:
              rest = n.slice(prefix.length);
              if (!(rest === '')) {
                _context8.next = 4;
                break;
              }
              return _context8.abrupt("continue", 5);
            case 4:
              slash = rest.indexOf('/');
              if (slash === -1) {
                if (!children.has(rest)) children.set(rest, false);
              } else {
                children.set(rest.slice(0, slash), true);
              }
            case 5:
              _context8.next = 2;
              break;
            case 6:
              _context8.next = 8;
              break;
            case 7:
              _context8.prev = 7;
              _t = _context8["catch"](1);
              _iterator3.e(_t);
            case 8:
              _context8.prev = 8;
              _iterator3.f();
              return _context8.finish(8);
            case 9:
              return _context8.abrupt("return", _toConsumableArray(children.entries()).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  name = _ref2[0],
                  isDir = _ref2[1];
                return {
                  name: name,
                  isDir: isDir
                };
              }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
              }));
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[1, 7, 8, 9]]);
      }));
      function listDir(_x14) {
        return _listDir.apply(this, arguments);
      }
      return listDir;
    }()
  }, {
    key: "readText",
    value: function () {
      var _readText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(rel, opts) {
        return _regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.readEntryText(rel, opts));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function readText(_x15, _x16) {
        return _readText.apply(this, arguments);
      }
      return readText;
    }()
  }, {
    key: "readBytes",
    value: function () {
      var _readBytes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(rel, opts) {
        return _regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              return _context0.abrupt("return", this.readEntryBytes(rel, opts));
            case 1:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function readBytes(_x17, _x18) {
        return _readBytes.apply(this, arguments);
      }
      return readBytes;
    }()
  }, {
    key: "entrySize",
    value: function entrySize(rel) {
      var e = this.byName.get(rel);
      return e ? e.uncompressedSize : null;
    }
  }, {
    key: "listEntries",
    value: function listEntries() {
      return this.entries.filter(function (e) {
        return !e.name.endsWith('/');
      }).map(function (e) {
        return {
          name: e.name,
          size: e.uncompressedSize
        };
      });
    }
  }]);
}();
/**
 * Open a sealed `.evidence` zip over a ranged ByteSource: read the central
 * directory once (tail + CD only), then range-read only the entries asked
 * for (decision 0041). `packName` is the pack's file base name.
 */
export function openPackZip(_x19, _x20, _x21) {
  return _openPackZip.apply(this, arguments);
}
function _openPackZip() {
  _openPackZip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(src, packName, opts) {
    var _yield$readEocd, cdOffset, cdSize, tail, tailStart, cd, entries, _t6;
    return _regeneratorRuntime.wrap(function (_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 1;
          return readEocd(src, opts);
        case 1:
          _yield$readEocd = _context12.sent;
          cdOffset = _yield$readEocd.cdOffset;
          cdSize = _yield$readEocd.cdSize;
          tail = _yield$readEocd.tail;
          tailStart = _yield$readEocd.tailStart;
          if (!(cdOffset >= tailStart)) {
            _context12.next = 2;
            break;
          }
          _t6 = tail.subarray(cdOffset - tailStart, cdOffset - tailStart + cdSize);
          _context12.next = 4;
          break;
        case 2:
          _context12.next = 3;
          return src.read(cdOffset, cdSize, opts);
        case 3:
          _t6 = _context12.sent;
        case 4:
          cd = _t6;
          _context12.next = 5;
          return parseCentralDirectory(cd);
        case 5:
          entries = _context12.sent;
          return _context12.abrupt("return", new ZipPackContainer(src, packName, entries));
        case 6:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _openPackZip.apply(this, arguments);
}